import { render, staticRenderFns } from "./certification.vue?vue&type=template&id=e8f2c6c4&scoped=true"
import script from "./certification.vue?vue&type=script&lang=js"
export * from "./certification.vue?vue&type=script&lang=js"
import style0 from "./certification.vue?vue&type=style&index=0&id=e8f2c6c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f2c6c4",
  null
  
)

export default component.exports